const Shared = require("Sources/shared");
const LanguageManager = require("Sources/services/language-manager");
const utils = require("Sources/utils/utils");

import UserServices from "../services/user-services";

require("Styles/pages/reset-password.scss");

$(function()
{
  Shared.init();
  ResetPasswordPage.init();
});

let ResetPasswordPage = {};

((ResetPasswordPage) =>
{

  ResetPasswordPage.init = function()
  {
    setUpEventListeners();
    clearAllFieldErrors();
  };

  function setUpEventListeners()
  {
    showEnterEmailPart();

    let $cancelResetPasswordBtn = $("#cancel-reset-password-btn");

    $cancelResetPasswordBtn.on("click", function () { utils.redirect("/login"); });

    $("#send-reset-mail-btn").on("click", function(e)
    {
      let emailEl = $("#email-input").removeClass("input-error");
      let email = emailEl.val();

      if(utils.isNullOrEmpty(email))
      {
        emailEl.addClass("is-invalid");

        e.preventDefault();
        return;
      }

      let $this = $(this);
      $this.prop("disabled", true).removeClass("btn-loading").addClass("btn-loading");

      UserServices.requestPasswordReset(email)
        .then((data) =>
        {
          $this.prop("disabled", false).removeClass("btn-loading");
          showEmailSentPart(email);

          emailEl.val("");
        })
        .catch((err) =>
        {
          let message = LanguageManager.getValueForKey(err.readableErrorMessage);
          $("#reset-password-email-input-error").text(message);

          $this.prop("disabled", false).removeClass("btn-loading");
        });
    });

    $("#reset-password-resend-btn").on("click", function () { showEnterEmailPart(); });
    $("#reset-password-to-login-btn").on("click", function () { utils.redirect("/login"); });
  }

  function showEnterEmailPart()
  {
    $("#part_enter_email").show();
    $("#part_mail_sent").hide();
  }

  function showEmailSentPart(email)
  {
    let message = LanguageManager.getValueForKey("reset_password.mail_sent_to");
    let formattedMessage = utils.format(message, [email]);
    $("#part_mail_sent_message").html(formattedMessage);

    $("#part_enter_email").hide();
    $("#part_mail_sent").show();
  }

  function clearAllFieldErrors()
  {
    $(".form-control").removeClass("is-invalid");
    $(".input-field-error").text("");
  }

})(ResetPasswordPage);



// WEBPACK FOOTER //
// ./app/js/entries/reset-password.js